import axios from "axios";
export const getUtilityTariffs = async (lat, long) => {
    let response = await axios.get(`https://api.openei.org/utility_rates?version=3&format=json&api_key=CUtAbQiQcyQcSmUJuDY45RZVgxrVawCFk0ZDFxz2&sector=Commercial&lat=${lat}&lon=${long}`, {
        headers: {
            'Accept': 'application/json',
        },
    });
    
    let tariffs = []
    response.data.items.forEach(item => {

        tariffs.push({
            openei_id: item.label,
            name: item.name,
            utility: item.utility,
            start: new Date(item.startdate * 1000),
            end : new Date(item.enddate * 1000),
            label: item.name + ' (Effective ' + new Date(item.startdate * 1000).getFullYear() + " - " + new Date(item.enddate * 1000).getFullYear() + ")"
        })
    });
    tariffs.sort((a, b) => (a.label > b.label) ? 1 : -1)
    console.log(tariffs)
    return tariffs
};
